<template lang="pug">
  .bread(v-if="bread")
    .bread__item-wr(v-for="item, i in bread", :key="item.id")
      router-link.bread__item(v-if="i !== bread.length - 1", :to="item.lnk") {{item.title}}
      .bread__item.bread__item--active(v-else) {{item.title}}
      span.bread__separator(v-if="i !== bread.length - 1") |

</template>

<script>
  // @ is an alias to /src
  import '@/components/common/bread/bread.styl';

  export default {
    name: 'Bread',

    data() {
      return {}
    },

    props: ['bread'],

    components: {

    },

    created() {

    },

    methods: {

    }
  }
</script>
